import {ICashboxType, CashboxTypeResponseType} from "@/entity/finance/cashbox/cashboxType.types";

export default class CashboxType implements ICashboxType {
    id: number;
    name: string;
    constructor(data: CashboxTypeResponseType) {
        this.id = data.id;
        this.name = data.name;
    }
}